export default __webpack_public_path__ + "static/media/cross.443a08ef.svg";